import React from 'react'
import { FaBoxOpen } from 'react-icons/fa6'

export default function Empty({ children }) {
    return (
        <div className='h-full flex flex-col justify-center items-center mx-6 py-10 text-center text-gray-400 animate-fade-in'>
            <FaBoxOpen className='text-5xl mb-3 text-gray-300' />
            <p className='text-lg sm:text-xl font-medium'>{children}</p>
        </div>
    )
}
